import React from "react";
import { PropTypes } from "prop-types";
import { MrbCollapsiblePanel } from "mrb/components/collapsible-panel";
import { observer } from "mobx-react";
import { Image } from "common/components";
import { MrbButton, MrbToggle } from "mrb";
import { currencyFormatter } from "mrb/common/formatting";

function LoadioArtistPreviewAlbumTemplate({ loadioArtistPreviewAlbumViewStore, t }) {
    const {
        album,
        isCollapsed,
        toggleIsActive,
        isActiveStatusDisabled,
        toggleCollapse,
        setPanelRef,
        onClickAlbumTrackList,
        coverImageUrl,
    } = loadioArtistPreviewAlbumViewStore;

    return (
        <MrbCollapsiblePanel
            title={album.title}
            innerRef={setPanelRef}
            t={t}
            isCollapsed={isCollapsed}
            onChangeCollapse={toggleCollapse}
            headerClassNameExtend="u-cursor--pointer"
            headerRender={(props) => <AlbumPanelHeader {...props} album={album} />}
        >
            {() => (
                <React.Fragment>
                    <div className="row">
                        <div className="col col-sml-12 col-huge-7 u-mar--top--sml u-mar--bottom--sml">
                            <div className="row">
                                {album?.price != null && (
                                    <div className="col col-sml-6 col-xlrg-3 col-huge-6 u-mar--bottom--sml">
                                        <p className="c-collapse-panel__body__label">
                                            {t("ADMINISTRATION.LOADIO.ARTIST.PREVIEW.ALBUM.FIELDS.PRICE")}
                                        </p>
                                        <p>
                                            {currencyFormatter.format(album.price, {
                                                currency: "USD",
                                            })}
                                        </p>
                                    </div>
                                )}
                                <div className="col col-sml-12">
                                    <div>
                                        <p className="c-collapse-panel__body__label">
                                            {t("ADMINISTRATION.LOADIO.ARTIST.PREVIEW.ALBUM.FIELDS.COVER_IMAGE")}
                                        </p>
                                        <Image className="c-upload__uploaded-img" src={coverImageUrl} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col col-sml-12 col-huge-5 u-mar--top--sml u-mar--bottom--sml">
                            <div className="c-toggle__card-list">
                                <div className="c-toggle__item--inline">
                                    {t("ADMINISTRATION.LOADIO.ARTIST.PREVIEW.ALBUM.BUTTONS.STATUS")}
                                    <MrbToggle
                                        id={`album-active-status-${album.id}`}
                                        value={album.isActive}
                                        disabled={isActiveStatusDisabled}
                                        onChange={(event) => toggleIsActive(event.target.checked)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <MrbButton
                        onClick={onClickAlbumTrackList}
                        className="c-btn c-btn--base c-btn--ghost"
                        label="ADMINISTRATION.LOADIO.ARTIST.PREVIEW.ALBUM.BUTTONS.TRACKS"
                        t={t}
                    />
                </React.Fragment>
            )}
        </MrbCollapsiblePanel>
    );
}

LoadioArtistPreviewAlbumTemplate.propTypes = {
    album: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

const AlbumPanelHeader = observer(function AlbumPanelHeader({ title, t, isCollapsed, album }) {
    return (
        <React.Fragment>
            <div className="u-display--flex u-display--flex--ai--center">{t(title)} </div>
            <div className="u-display--flex u-display--flex--ai--center">
                <i
                    className={`u-icon u-icon--med u-icon--arrow-down ${
                        isCollapsed ? "u-rotate--180" : ""
                    } u-cursor--pointer`}
                ></i>
            </div>
        </React.Fragment>
    );
});

export default observer(LoadioArtistPreviewAlbumTemplate);
